<template functional>
  <el-switch
    style="display: block"
    v-bind:value="
      [1, 'SI'].includes(props.row[`${props.column}`]) ? true : false
    "
    active-color="#6BA652"
    inactive-color="#ff4c4c"
  >
  </el-switch>
</template>

<script>
export default {
  name: 'SwitchFormatter',
};
</script>
